"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = updateInputWidth;

function getFontShorthand(element) {
  var style = window.getComputedStyle(element);
  return style.font || "".concat(style['font-style'], " ").concat(style['font-variant'], " ").concat(style['font-weight'], " ").concat(style['font-size'], "/").concat(style['line-height'], " ").concat(style['font-family']);
}

function updateInputWidth(element) {
  if (typeof window === 'undefined') {
    return null;
  }

  var font = getFontShorthand(element);
  var text = element.value || element.placeholder;
  var canvas = updateInputWidth.canvas || (updateInputWidth.canvas = document.createElement('canvas'));
  var context = canvas.getContext('2d');
  context.font = font;

  var _context$measureText = context.measureText(text),
      width = _context$measureText.width;

  var ceilWidth = Math.ceil(width);
  element.style.width = "".concat(ceilWidth, "px");
  return ceilWidth;
}